import * as actionTypes from "./actions"; //This has the list of actions. Now you don't have to type the string
//value for the action name. That would cause a error if you have a typo
//
//the initialState when you start the app
const initialState = {
	APIUrl: process.env.REACT_APP_BACKEND_URL,

	//used for the search project page
	searched_projects_results: [],

	//used when creating rooms in project setup page
	rooms: [],
	roomsIdToDelete: [],
	updatedRooms: [],
	addNewProjectRoomsToAddToTheDatabase: [],

	//used when logging in
	trendId: "",
	initialLogin: false,

	// States used for deleting certain settings of a consultant. We send these to the backend
	consultantWarehousesDeletingList: [],
	consultantEmailsDeletingList: [],

	// States used to add new settings to a consultant. We also send these to the backend
	addTheseToConsultantWarehouses: [],
	addTheseToConsultantEmails: [],

	// These are the states used for product shopping
	listOfProductCardsToDisplay: [],
	selectedGroupMap: {},
	roomNames: [],
	roomIds: [],
	accountIdForTheProjectYouAreShoppingFor: "",
	projectIdUsedToIncreaseProductQuantity: "", // we also use this in other components like the header component in the check prices handler function. The header/nav is where they want check prices button to display and new project is NOT a direct child from the header component. So, I didn't know how else to do it and I don't think it's worth the time to spend time on something small like this when i can do it this way and it will work perfectly fine. There is no negative side effect of doing it this way.

	// These states are used for the project quote screen
	warehouseNumber: "",

	isThisProjectActingAsAnAgent: null,

	// We used this to tell the header/nav component to display the check prices button when on the project set up page
	// Could not use the normal change the parent state to display it because project setup is NOT a direct child from the header/nav component
	displayCheckPricesButtonOnNavBar: false,
	displayCheckProductDetailsOnNavBar: false,
	displayProductShoppingButtonOnNavBar: false,
	display_quote_link_on_nav_bar: false,

	// we stored the ship to because we need it in product shopping to display non stock
	storeThisProjectShipToForDisplayingNonStockInProductShopping: null,

	// The name of this redux state says it all
	selected_project_warehouse_number_for_product_shopping_nav_bar_link: null,

	// Counter to note when product details update was triggered
	details_updated: 1,

	// The below state is used for translation
	selected_language: null,
	language_translations: null
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.SAVE_USER: //ADD_PERSOn value can be found in the action.js file that we imported
			return {
				...state, //this makes it immutable which is a good practice. It means cloning.
				initialLogin: true
			};
		case actionTypes.SAVE_SEARCHED_PROJECTS_RESULTS:
			return {
				...state, //this makes it immutable which is a good practice. It means cloning.
				searched_projects_results: action.searched_projects_results
			};
		case actionTypes.DELETE_PROJECT_ROOM:
			return {
				...state, //this makes it immutable which is a good practice. It means cloning.
				rooms: [
					state.rooms.slice(0, action.roomIndex),
					state.rooms.slice(action.roomIndex + 1)
				],
				roomsIdToDelete: state.roomsIdToDelete.concat(action.roomId)
			};
		case actionTypes.UPDATE_PROJECT_ROOM:
			return {
				...state, //this makes it immutable which is a good practice. It means cloning.
				updatedRooms: state.updatedRooms.concat(action.updatedRoom)
			};
		case actionTypes.SAVE_PROJECT_ROOMS:
			return {
				...state, //this makes it immutable which is a good practice. It means cloning.
				rooms: action.rooms === null ? [...state.rooms] : action.rooms,
				roomNames: action.roomNames,
				roomIds: action.roomIds
			};
		case actionTypes.CLEAR_UPDATED_ROOMS_GLOBAL_STATE:
			return {
				...state, //this makes it immutable which is a good practice. It means cloning.
				roomsIdToDelete: [],
				updatedRooms: [],
				addNewProjectRoomsToAddToTheDatabase: [],
				rooms: []
			};
		case actionTypes.CLEAR_ROOM_NAMES:
			return {
				...state, //this makes it immutable which is a good practice. It means cloning.
				roomNames: [],
				listOfProductCardsToDisplay: [],
				selectedGroupMap: {},
			};
		case actionTypes.ADD_NEW_PROJECT_ROOM_TO_ADD_TO_THE_DATABASE:
			return {
				...state, //this makes it immutable which is a good practice. It means cloning.
				addNewProjectRoomsToAddToTheDatabase: state.addNewProjectRoomsToAddToTheDatabase.concat(
					action.roomName
				)
			};
		case actionTypes.LOG_OUT:
			return {
				...state,
				initialLogin: !state.initialLogin
			};
		case actionTypes.DELETE_CONSULTANT_WAWREHOUSE:
			return {
				...state,
				consultantWarehousesDeletingList: state.consultantWarehousesDeletingList.concat(
					action.recordId
				)
			};
		case actionTypes.UPDATE_LIST_OF_PRODUCT_CARDS_TO_DISPLAY:
			return {
				...state,
				listOfProductCardsToDisplay: action.newListOfProductCardsToDisplay
			};
		case actionTypes.SAVE_ACCOUNT_ID_FOR_GETTING_PRODUCT_INFORMATION_LATER:
			return {
				...state,
				accountIdForTheProjectYouAreShoppingFor: action.accountId
			};
		case actionTypes.SAVE_PROJECT_ID_TO_INCREASE_THE_QUANTITY_OF_A_PRODUCT:
			return {
				...state,
				projectIdUsedToIncreaseProductQuantity: action.projectId
			};
		case actionTypes.DISPLAY_PRODUCT_SHOPPING_BUTTON_ON_NAV_BAR:
			return {
				...state,
				displayProductShoppingButtonOnNavBar: action.displayOrNot,
				selected_project_warehouse_number_for_product_shopping_nav_bar_link:
					action.selected_project_warehouse_number ===
					"warehouse_number_has_not_been_provided_for_this_project"
						? state.selected_project_warehouse_number_for_product_shopping_nav_bar_link
						: action.selected_project_warehouse_number
			};
		case actionTypes.STOP_DISPLAYING_QUOTE_NAV_BUTOTN:
			return {
				...state,
				displayQuoteNavButton: action.displayOrNot
			};
		case actionTypes.SAVE_WAREHOUSE_NUMBER_FOR_QUOTE_SCREEN:
			return {
				...state,
				warehouseNumber: action.warehouseNumber
			};
		case actionTypes.SAVING_ACTING_AS_AN_AGENT:
			return {
				...state,
				isThisProjectActingAsAnAgent: action.saveActingAsAnAgent
			};
		case actionTypes.DISPLAY_CHECK_PRICES_BUTTON_ON_NAV_BAR:
			return {
				...state,
				displayCheckPricesButtonOnNavBar: action.displayOrNot
			};
		case actionTypes.DISPLAY_CHECK_PRODUCT_DETAILS_ON_NAV_BAR:
			return {
				...state,
				displayCheckProductDetailsOnNavBar: action.displayOrNot
			};
		case actionTypes.DISPLAY_QUOTE_LINK_ON_NAV_BAR:
			return {
				...state,
				display_quote_link_on_nav_bar: action.displayOrNot
			};
		case actionTypes.STORE_THIS_PROJECT_SHIP_TO_FOR_DISPLAYING_NON_STOCK_IN_PRODUCT_SHOPPING:
			return {
				...state,
				storeThisProjectShipToForDisplayingNonStockInProductShopping: action.shipToName
			};
		case actionTypes.TOGGLE_LANGUAGE:
			return {
				...state,
				language_translations:
					action.language_translations === null ||
					action.language_translations === undefined
						? state.language_translations
						: action.language_translations,
				selected_language:
					state.selected_language === null
						? "en"
						: state.selected_language === "en"
						? "fr"
						: "en"
			};
		case actionTypes.UPDATE_SELECTED_GROUPS:
			return {
				...state,
				selectedGroupMap: action.updatedSelectedGroupMap,
			};
		case actionTypes.ALERT_DETAILS_UPDATE:
			return {
				...state,
				details_updated: state.details_updated+1,
			};

		default:
	}

	return state;
};

export default reducer;
